<script>
export default {
	async mounted() {
		const mouse_flow_enabled = (process.env.VUE_APP_MOUSEFLOW_ENABLED == 'true') ? true : false;
		const mouse_flow_src = process.env.VUE_APP_MOUSEFLOW_SRC;
		if (mouse_flow_enabled) {
			window._mfq = window._mfq || [];
			(function() {
				var mf = document.createElement('script');
				mf.type = 'text/javascript';
				mf.defer = true;
				mf.src = mouse_flow_src;
				document.getElementsByTagName('head')[0].appendChild(mf);
			})();
			console.log('🐁 MouseFlow Loaded...');
		} else {
			console.log('🐁 MouseFlow NOT Loaded...');
		}
	}
};
</script>
